import React from "react";
import ListPage from "./components/ListPage";
import { ContentCard } from "./components/ui";
import { useContentModal } from "./components/ContentModal";
import { formatDate } from "./utils/time";

const PoliciesList = () => {
    // Policies open in a modal, in place — not a new page.
    const { openContent } = useContentModal();

    return (
        <ListPage
            eyebrow="Compliance"
            title="Policies & Guidelines"
            intro="How we work, and what we hold ourselves to."
            endpoint="/api/Dolluzcorp/policies/list"
            empty={{
                icon: "🛡️",
                title: "No policies here yet",
                message: "There's nothing published at the moment. Policies will appear here as they're added.",
                noun: "policy",
                nounPlural: "policies",
            }}
            renderCard={(p) => (
                <ContentCard
                    key={p.policy_id}
                    onOpen={() => openContent("policy", p.policy_id)}
                    kind="Policy"
                    title={p.title}
                    /* The teaser is plain text from the server — `excerpt`, or a trimmed
                       slice of the body when excerpt is NULL (which is every row today). */
                    teaser={p.excerpt}
                    meta={formatDate(p.updated_time || p.created_time)}
                    footer="Read policy"
                />
            )}
        />
    );
};

export default PoliciesList;
